import React from 'react';

interface Barbershop3DIconProps {
  size?: number;
  color?: string;
}

export const Barbershop3DIcon = ({ size = 48, color = '#E91E63' }: Barbershop3DIconProps) => {
  const darkerColor = adjustBrightness(color, -40);
  const lighterColor = adjustBrightness(color, 50);
  const metalLight = '#E8E8E8';
  const metalDark = '#999999';
  const metalMid = '#CCCCCC';

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="59" rx="16" ry="3" fill="rgba(0,0,0,0.15)" />

      {/* Left handle ring */}
      <ellipse cx="22" cy="50" rx="7" ry="8" fill={color} stroke={darkerColor} strokeWidth="1.5" transform="rotate(10, 22, 50)" />
      <ellipse cx="22" cy="50" rx="4" ry="5.5" fill={darkerColor} transform="rotate(10, 22, 50)" />
      <ellipse cx="21.5" cy="49" rx="3" ry="4.5" fill={lighterColor} opacity="0.25" transform="rotate(10, 22, 50)" />

      {/* Right handle ring */}
      <ellipse cx="42" cy="50" rx="7" ry="8" fill={color} stroke={darkerColor} strokeWidth="1.5" transform="rotate(-10, 42, 50)" />
      <ellipse cx="42" cy="50" rx="4" ry="5.5" fill={darkerColor} transform="rotate(-10, 42, 50)" />
      <ellipse cx="42.5" cy="49" rx="3" ry="4.5" fill={lighterColor} opacity="0.25" transform="rotate(-10, 42, 50)" />

      {/* Left blade */}
      <path d="M26 42 C25 38, 22 30, 18 12 C17.5 10, 19 9, 20 10 C24 14, 28 28, 30 34 Z" fill={metalLight} stroke={metalDark} strokeWidth="0.8" />
      <path d="M26 42 C25.5 39, 23 32, 19.5 14 C20.5 15, 26 30, 29 36 Z" fill={metalMid} opacity="0.5" />
      {/* Left blade edge highlight */}
      <path d="M18.5 12 C22 20, 25 32, 27 38" stroke="white" strokeWidth="0.5" opacity="0.4" fill="none" />

      {/* Right blade */}
      <path d="M38 42 C39 38, 42 30, 46 12 C46.5 10, 45 9, 44 10 C40 14, 36 28, 34 34 Z" fill={metalLight} stroke={metalDark} strokeWidth="0.8" />
      <path d="M38 42 C38.5 39, 41 32, 44.5 14 C43.5 15, 38 30, 35 36 Z" fill={metalMid} opacity="0.5" />
      {/* Right blade edge highlight */}
      <path d="M45.5 12 C42 20, 39 32, 37 38" stroke="white" strokeWidth="0.5" opacity="0.4" fill="none" />

      {/* Pivot screw */}
      <circle cx="32" cy="38" r="4" fill={metalDark} />
      <circle cx="32" cy="38" r="3" fill={metalLight} />
      <circle cx="32" cy="38" r="1.5" fill={metalDark} />
      <circle cx="31.5" cy="37.5" r="0.8" fill="white" opacity="0.5" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
